module.exports = __webpack_public_path__ + "static/media/magnifying.5704b03b.svg";